import service from "@/store/services/inspection-fields-service";
import Jsona from "jsona";
import { cloneDeep } from "lodash";
import store from "..";

const jsona = new Jsona();

export const state = () => ({
  list: {},
  inspectionField: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, inspectionField) => {
    state.inspectionField = inspectionField;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((inspectionField) => {
      commit("SET_RESOURCE", inspectionField);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((inspectionField) => {
      commit("SET_RESOURCE", inspectionField);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((inspectionField) => {
      if(inspectionField.inspectionSectionScores) {
        const inspectionData = cloneDeep(store.getters["inspections/currentInspection"]);
        inspectionData.sectionsScores = inspectionField.inspectionSectionScores;
        store.dispatch("inspections/setCurrentInspection", inspectionData);
      }
      commit("SET_RESOURCE", inspectionField);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  inspectionField: (state) => state.inspectionField,
  url: (state) => state.url,
};

const inspectionFields = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default inspectionFields;
